import FeaturedDatePicker from './FeaturedDatePicker';
import RangeDatePicker from './RangeDatePicker';

export {
  RangeDatePicker
};
export default FeaturedDatePicker;